import { Link } from "react-router-dom";
import { usePromo } from "../hooks/usePromo";
import { getListingUrl } from "../../../utils/url.utils";

function PromoSection() {
  const { promoData, loading } = usePromo();

  if (loading || !promoData.length) return null;

  return (
    <section className="flat_overview">
      <div className="promo-section">
        {promoData.map((item) => (
          <div className="promo-card" key={item.id}>
            <Link to={getListingUrl(item.action_url)} target="_blank">
              <img
                src={item.media}
                alt={item.name}
                className="promo-image pointer-crusser"
              />
              <p className="promo-title pointer-crusser">
                {item.name}
              </p>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

export default PromoSection;